"use client";

import { registerLicense } from "@syncfusion/ej2-base";

// Register once at app root, before any Syncfusion component mounts.
// Key is supplied via NEXT_PUBLIC_SYNCFUSION_LICENSE_KEY environment variable.
registerLicense(process.env.NEXT_PUBLIC_SYNCFUSION_LICENSE_KEY ?? "");

// This component renders nothing — it exists only to run the side-effect above.
export default function SyncfusionLicense() {
  return null;
}
